"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopover = void 0;
var react_1 = __importStar(require("react"));
var Overlay_1 = __importDefault(require("../Overlay/Overlay"));
exports.usePopover = function (_a) {
    var placement = _a.placement, triggerReference = _a.triggerReference, content = _a.content, _b = _a.openOn, openOn = _b === void 0 ? 'mouse-over' : _b, _c = _a.closeOn, closeOn = _c === void 0 ? 'mouse-out' : _c, _d = _a.effect, effect = _d === void 0 ? 'fade' : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? false : _e, _f = _a.keepOpenOnHover, keepOpenOnHover = _f === void 0 ? true : _f, _g = _a.closeOnEnter, closeOnEnter = _g === void 0 ? false : _g, onOpen = _a.onOpen, onClose = _a.onClose, showArrow = _a.showArrow, cssClass = _a.cssClass, onOverlayKeyDown = _a.onOverlayKeyDown;
    var _h = react_1.default.useState(false), isVisible = _h[0], setVisibility = _h[1];
    var _j = react_1.default.useState(0), timer = _j[0], setTimer = _j[1];
    var localTimer = timer;
    var overlayRef = react_1.default.useRef(null);
    var _k = react_1.useState(0), refresh = _k[0], doRefresh = _k[1];
    var closableWithMouse = closeOn === 'mouse-out' || closeOn === 'mouse-out-and-click';
    var openOnClick = openOn === 'click';
    var triggerRef = react_1.default.useRef(null);
    if (triggerReference) {
        triggerRef = triggerReference;
    }
    var onOutsideClick = function () {
        if (isVisible) {
            close();
        }
    };
    var onTriggerClick = function () {
        if (isVisible && openOnClick) {
            close();
        }
        if (!isVisible && openOnClick) {
            open();
        }
    };
    var refreshPosition = function () {
        doRefresh(function (prev) { return prev + 1; });
    };
    var open = function () {
        refreshPosition();
        cancelCloseRequest();
        var wasVisible = isVisible;
        setVisibility(true);
        if (onOpen && !wasVisible) {
            onOpen();
        }
    };
    var close = function () {
        if (isVisible) {
            cancelCloseRequest();
            setVisibility(false);
            if (onClose) {
                onClose();
            }
        }
    };
    var cancelCloseRequest = function () {
        if (localTimer) {
            window.clearTimeout(localTimer);
            localTimer = 0;
            setTimer(0);
        }
    };
    var getMenuItems = function () {
        if (overlayRef.current) {
            return [].slice.call(overlayRef.current.querySelectorAll('[role="menuitem"]'));
        }
        return [];
    };
    var triggerKeyDown = function (e) {
        var _a, _b;
        var menuItems = getMenuItems();
        var index = menuItems.indexOf(e.target);
        switch (e.key) {
            case 'ArrowUp':
                // Prevent browser scroll
                e.preventDefault();
                if (index < 0) {
                    open();
                }
                index = index > 0 ? index - 1 : menuItems.length - 1;
                (_a = menuItems[index]) === null || _a === void 0 ? void 0 : _a.focus();
                break;
            case 'Enter':
                if (triggerRef.current) {
                    var htmlElement = e.target;
                    if (htmlElement.click) {
                        htmlElement.click();
                        if (closeOnEnter) {
                            close();
                        }
                    }
                }
                break;
            case 'Tab':
                if (index >= menuItems.length - 1) {
                    close();
                }
                break;
            case 'Escape':
                close();
                if (triggerRef.current) {
                    var htmlElement = triggerRef === null || triggerRef === void 0 ? void 0 : triggerRef.current;
                    if (htmlElement.focus) {
                        htmlElement.focus();
                    }
                }
                break;
            case 'ArrowDown':
                // Prevent browser scroll
                e.preventDefault();
                if (index < 0) {
                    open();
                }
                index = index === menuItems.length - 1 ? 0 : index + 1;
                (_b = menuItems[index]) === null || _b === void 0 ? void 0 : _b.focus();
                break;
        }
    };
    var requestClose = function () {
        if (isVisible && closableWithMouse) {
            if (!keepOpenOnHover) {
                close();
            }
            if (localTimer === 0) {
                var handle = window.setTimeout(function () {
                    close();
                    localTimer = 0;
                    setTimer(0);
                }, 275);
                localTimer = handle;
                setTimer(localTimer);
            }
        }
    };
    var overlay = (react_1.default.createElement(Overlay_1.default, { overlayRef: overlayRef, onMouseEnter: function () {
            if (keepOpenOnHover) {
                open();
            }
        }, onMouseLeave: function () {
            requestClose();
        }, fullWidth: fullWidth, effect: effect, isVisible: isVisible, targetRef: triggerRef, placement: placement, childNode: content({ isOpen: isVisible }), refresh: refresh, onClickOutside: onOutsideClick, onOverlayKeyDown: function (e) {
            // Do not add "preventDefault" here since it will prevent  input[text] from working and recieving input
            // To preventDefault make sure no input have focus
            triggerKeyDown(e);
            if (onOverlayKeyDown) {
                onOverlayKeyDown(e);
            }
        }, showArrow: showArrow, cssClass: cssClass }));
    var onTriggerMouseEnter = function () {
        if (openOn === 'mouse-over' ||
            ((closeOn === 'mouse-out-and-click' || closeOn === 'mouse-out') && isVisible)) {
            open();
        }
    };
    var onTriggerMouseLeave = function () {
        requestClose();
    };
    var returnValue = {
        triggerRef: triggerRef,
        overlayRef: overlayRef,
        overlay: overlay,
        onTriggerClick: onTriggerClick,
        onTriggerMouseEnter: onTriggerMouseEnter,
        onTriggerMouseLeave: onTriggerMouseLeave,
        close: close,
        openPopover: open,
        refreshPosition: refreshPosition,
        isOpen: isVisible,
        onTriggerKeyDown: triggerKeyDown
    };
    return returnValue;
};
